// extracted by mini-css-extract-plugin
export default {"btnShowActions":"ActionsMenu_btnShowActions__qf+ps","menu":"ActionsMenu_menu__6Vizr","menuList":"ActionsMenu_menuList__NZq7u","menuItem":"ActionsMenu_menuItem__x28UH"};